import { createContext } from 'react'

import { DevicesManagerType } from '../hooks/devices/use_devices_manager'

export const DevicesContext = createContext<DevicesManagerType>({
  initialized: false,
  audioDevices: {},
  videoDevices: {},
  audioOutputDevices: {},
  hasAudioDevices: false,
  hasVideoDevices: false,
  hasAudioOutputDevices: false,
  askForPermission: undefined,
  permissionStates: {},
  invalidateDevices: undefined,
  speakerSupport: false,
  pendingPermissionRequests: { camera: false, microphone: false}
})
